<!-- <header
  class="MuiPaper-root MuiPaper-elevation MuiPaper-elevation4 MuiAppBar-root MuiAppBar-colorPrimary MuiAppBar-positionFixed mui-fixed mui-style-wne33u">
  <div class="MuiBox-root mui-style-1l5h1fr">
    <div class="MuiToolbar-root MuiToolbar-regular mui-style-1f2p3pb">
      <div class="MuiGrid-root MuiGrid-container MuiGrid-spacing-xs-2 mui-style-1j2yjj3">
        <div class="MuiGrid-root MuiGrid-item MuiGrid-grid-md-7 mui-style-1m5ny0b">
          <div class="MuiBox-root mui-style-oc6i0x">
            <span style="
                box-sizing: border-box;
                display: inline-block;
                overflow: hidden;
                width: 120px;
                height: 50px;
                background: none;
                opacity: 1;
                border: 0;
                margin: 0;
                padding: 0;
                position: relative;
              "><img alt="NFL Logo" src="{{('HOMELAYOUT.HEADERIMG_IMG' | optimotranslate) + '?imwidth=256'}}"
                decoding="async" data-nimg="fixed" style="
                  position: absolute;
                  top: 0;
                  left: 0;
                  bottom: 0;
                  right: 0;
                  box-sizing: border-box;
                  padding: 0;
                  border: none;
                  margin: auto;
                  display: block;
                  width: 0;
                  height: 0;
                  width: 80px !important;
                  height: 20px !important;
                " srcset="
                {{('HOMELAYOUT.HEADERIMG_IMG' | optimotranslate) + '?imwidth=256'}} 1x,
                {{('HOMELAYOUT.HEADERIMG_IMG' | optimotranslate) + '?imwidth=640'}} 2x
                " /></span>
          </div>
          <div class="header-lable">
            <h6>{{'HOMELAYOUT.HOSPITALITY BOOKINGS PORTAL -'| optimotranslate | uppercase}}
            </h6>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="mui-style-1vk76n2">
    <span style="
        box-sizing: border-box;
        display: inline-block;
        overflow: hidden;
        width: 110px;
        height: 20px;
        background: none;
        opacity: 1;
        border: 0;
        margin: 0;
        padding: 0;
        position: relative;
      ">
    </span>
    <p class="MuiTypography-root MuiTypography-body1 mui-style-s244od">
      The Official Way to Pay
    </p>
  </div>
</header> -->
<header id="header" class="header-ole force-display mui-style-wne33u" [ngStyle]="{ 'display': isInternalUser ? 'none' : 'flex' }">
  <div class="header__button">
    <div class="hamburger__container">
      <!-- <button id="hamburger" type="button" class="header__hamburger">
        <div class="header__hamburger__icon">
          <span></span>
          <span></span>
        </div>
        <span class="header__hamburger__text">Menu</span>
      </button> -->
    </div>
    <div class="links">
    </div>
  </div>
  <div class="header__logo">
    <a class="header-link logo" href="https://imgexp.com/">
      <h1 class="home-logo">
        <div class="logo-div" title="IMG Events" style=""></div>
      </h1>
    </a>
  </div>
  <div class="header__account">
    <div class="search-button">
    </div>
    <div class="log-container hidden">
      <!-- <a href="#" class="sign-up sign-up-link">Create Account</a>
      <a href="#" class="login-link">Log In</a> -->
    </div>
    <div class="login-order desktop">
      <a class="login-numb" style="text-decoration: none !important;" href="tel:02081576511" aria-label="Contact us at 020 8157 6511" title="020.8157.6511">
        <span style="font-size:15px !important;">020.8157.6511</span>
      </a>
      <mat-icon class="black-icon">headset_mic</mat-icon>
    </div>

    <div class="login-order mobile">
      <a class="login-numb" style="text-decoration: none !important;" href="tel:02081576511" aria-label="Contact us at 020 8157 6511" title="020.8157.6511">
        <mat-icon class="black-icon">headset_mic</mat-icon>
      </a>
    </div>
  </div>
</header>
